var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.75 21.7969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 21.7969,
    opacity: 0,
    width: 15.75,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8906C0 11.2344 0.140625 11.5469 0.390625 11.8125L10.0469 21.4062C10.2812 21.6562 10.6094 21.7812 10.9688 21.7812C11.7031 21.7812 12.25 21.2344 12.25 20.5C12.25 20.1406 12.1094 19.8281 11.875 19.5781L3.15625 10.8906L11.875 2.20312C12.1094 1.95312 12.25 1.625 12.25 1.28125C12.25 0.546875 11.7031 0 10.9688 0C10.6094 0 10.2812 0.125 10.0469 0.375L0.390625 9.96875C0.140625 10.2344 0 10.5469 0 10.8906Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.8861edf2380a25d01707992a1f790829.svg";
export { ForwardRef as ReactComponent };